module.exports = __webpack_public_path__ + "static/media/talking.0f972adb.jpg";